export default "__VITE_ASSET__B1L81iqy__"